'use client';

import { decodeBookingJwtPayload, getAzDanceBookingToken } from '@/lib/azdanceBookingSession';

type ContextValue = string | number | boolean | null | undefined;
export type TelemetryContext = Record<string, ContextValue>;

function readUserTypeFromPersistedStore(): 'authenticated' | 'guest' {
  try {
    const raw = window.localStorage.getItem('aztf-registration');
    if (!raw) return 'guest';
    const parsed = JSON.parse(raw) as { state?: { currentUser?: unknown } };
    return parsed?.state?.currentUser ? 'authenticated' : 'guest';
  } catch {
    return 'guest';
  }
}

export function getTelemetryContext(): TelemetryContext {
  if (typeof window === 'undefined') return {};

  const token = getAzDanceBookingToken();
  const payload = token ? decodeBookingJwtPayload(token) : null;
  const sessionId = payload?.sub ?? null;

  return {
    path: window.location.pathname,
    locale: window.location.pathname.split('/').filter(Boolean)[0] ?? 'en',
    user_type: readUserTypeFromPersistedStore(),
    session_id: sessionId,
  };
}
